export const homepageDefaults = {
  hero: {
    eyebrow: 'School of Shem',
    title: 'Build with wisdom. Lead with purpose.',
    subtitle:
      'A premium Kingdom learning ecosystem equipping leaders, families, and builders to turn revelation into practical, generational impact.'
  },
  heroSlides: [
    {
      src: '/School Of SHEM Welcome.png',
      link: '/academics/faculties'
    },
    {
      src: '/School Of SHEM Millionaires Connect Banner.png',
      link: '/academics/faculties/millionaires-connect'
    },
    {
      src: '/School Of SHEM Masters Of The Economy Banner.png',
      link: '/academics/faculties/masters-of-the-economy'
    },
    {
      src: '/School Of SHEM Success Paradigms 101 Banner.png',
      link: '/academics/faculties/success-paradigms-101'
    },
    {
      src: '/School Of SHEM Building A family Economy.png',
      link: '/academics/faculties/building-a-family-economy'
    },
    {
      src: '/School Of SHEM Married And Loving It Banner.png',
      link: '/academics/faculties/married-and-loving-it'
    },
    {
      src: '/School Of SHEM Kingdom Kids 365.png',
      link: '/academics/faculties/kingdom-kids-365'
    }
  ],
  courses: {
    heading: 'Courses we offer at School of Shem',
    buttonLabel: 'View all Courses',
    cards: [
      {
        title: 'Millionaires Connect',
        description: '90-day wealth coaching intensive with structure, accountability, and execution habits.',
        image: '/logos/millionaires_connect_transparent.png',
        link: '/academics/faculties/millionaires-connect'
      },
      {
        title: 'Masters of the Economy',
        description: 'One-year journey to build a Kingdom economic blueprint and sustainable success.',
        image: '/logos/masters_economy_transparent.png',
        link: '/academics/faculties/masters-of-the-economy'
      },
      {
        title: 'Transformational Leadership School',
        description: 'Practical leadership modules to strengthen character, vision, and influence.',
        image: '/logos/leadership_school_transparent.png',
        link: '/academics/faculties/transformational-leadership'
      },
      {
        title: 'Kingdom Parenting 101',
        description: 'Family governance, identity, and discipleship for generational strength.',
        image: '/logos/kingdom_parenting_transparent.png',
        link: '/academics/faculties/kingdom-parenting-101'
      }
    ]
  },
  video: {
    heading: 'Video of the Week',
    url: 'https://www.youtube.com/watch?v=3APRgXcIiOg'
  },
  whyChoose: {
    heading: 'Why choose School of Shem',
    cards: [
      {
        title: '13 faculties, one ecosystem',
        description: 'Choose a focused pathway and grow across wealth, leadership, family, faith, education, and culture without losing alignment.'
      },
      {
        title: 'Flagship entry: Millionaires Connect',
        description: 'A 90-day wealth intensive that builds disciplined financial systems, weekly execution habits, and accountability.'
      },
      {
        title: 'Masters of the Economy',
        description: 'A one-year blueprint journey that guides you from concept to execution for sustainable Kingdom economics.'
      },
      {
        title: 'Leadership & Success formation',
        description: 'Transformational Leadership School and Success Paradigms 101 build character, clarity, and influence.'
      },
      {
        title: 'Family & legacy governance',
        description: 'Kingdom Parenting 101 and Marriage courses build order, unity, and generational strength.'
      },
      {
        title: 'Faith & spiritual formation',
        description: 'Faith Life and Total Life Transformation strengthen identity, obedience, and spiritual confidence.'
      }
    ]
  },
  events: {
    heading: 'Upcoming Events',
    copy: 'Events posted by the School of Shem team appear here automatically so visitors can register quickly.',
    buttonLabel: 'View all Events'
  },
  cta: {
    title: 'Ready to begin your journey?',
    subtitle: 'Apply today or sign up for updates on upcoming cohorts.'
  }
};
